<template>
    <div class="py-20 py-md-30 border-bottom border-color-light">
        <v-row>
            <v-col cols="12" sm="2" data-aos="fade-right">
                <div class="px-20 pr-sm-0">
                    <p class="page-text--sm font-weight-bold">
                        {{tit}}
                    </p>
                </div>
            </v-col>
            <v-col cols="12" sm="10" class="mt-n14 mt-sm-0" data-aos="fade-left">
                <div class="px-20 pl-sm-0">
                    <p class="font-size-12 font-size-lg-16 color-grey-7">
                        <slot/>
                    </p>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default{
    props : {
        tit : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>